export default __webpack_public_path__ + "src/assets/contract-interact.e1631aca315f2e31b1b5e489471c8f79.svg";